import { render } from "./quantity-selector.vue?vue&type=template&id=36b638c8"
import script from "./quantity-selector.vue?vue&type=script&lang=js"
export * from "./quantity-selector.vue?vue&type=script&lang=js"

import "./quantity-selector.vue?vue&type=style&index=0&id=36b638c8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__